module.exports = __webpack_public_path__ + "static/media/pe.882b9bd6.svg";